<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 18V6H17.5V18H14ZM6.5 18V6H10V18H6.5Z" fill="inherit" stroke="none" />
    </svg>
  </span>
</template>
